/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import {
  Grid,
  Avatar,
  Box,
  Button,
  Dialog,
  Slide,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Tab,
  Tabs,
  touchRippleClasses,
} from "@mui/material";
import pr from "../lib/pr";
import get_token from "../lib/get_token";
import { useEffect, useState } from "react";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { TabList, TabContext, TabPanel } from "@mui/lab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link } from "react-router-dom";
import queryString from "query-string";
import MypageLoggedCouponClass from "./MypageLoggedCouponClass";
import MypageLoggedCouponPass from "./MypageLoggedCouponPass";
import MypageLoggedCouponDiscount from "./MypageLoggedCouponDiscount";
import MypageLoggedCouponPT from "./MypageLoggedCouponPT";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";

const tabTheme = createTheme({
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          width: "33%",
          "&&.Mui-selected": {
            background: "#0092a2",
            color: "white",
            width: "33%",
            fontSize: '12px',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "30px",
          height: "30px",
          width: "100%",
          margin: "0 20px",
        },
        flexContainer: {
          minHeight: "30px",
          height: "30px",
          alignItems: "center",
          justifyContent: "space-between",
        },
        indicator: {
          display: "none",
        },
        scroller: {
          border: "1px solid #e5e5e5",
          borderRadius: "5px",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '12px',
        }
      }
    }
  },
});

const tabPTTheme = createTheme({
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          width: "25%",
          "&&.Mui-selected": {
            background: "#0092a2",
            color: "white",
            width: "25%",
            fontSize: '12px',
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "30px",
          height: "30px",
          width: "100%",
          margin: "0 20px",
        },
        flexContainer: {
          minHeight: "30px",
          height: "30px",
          alignItems: "center",
          justifyContent: "space-between",
        },
        indicator: {
          display: "none",
        },
        scroller: {
          border: "1px solid #e5e5e5",
          borderRadius: "5px",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '12px',
        }
      }
    }
  },
});

const MypageLoggedCoupon = (props) => {
  const { login } = props;
  const [loaded, setLoaded] = useState(false);
  const token = get_token();
  const [rows, setRows] = useState([]);
  const history = useHistory();
  const [stat, setStat] = useState(false);
  const [classCoupon, setClassCoupon] = useState(true);
  const [passCoupon, setPassCoupon] = useState(false);
  const [discountCoupon, setDiscountCoupon] = useState(false);
  const cid = get_cid();
  const center = get_center(cid);
  const [showPassCoupon, setShowPassCoupon] = useState(false);

  // URL에서 탭 바꾸기
  let { cate } = queryString.parse(window.location.search);
  if (cate === undefined) cate = "1";
  const [tab, setTab] = useState(cate);

  const onGoBookClick = (event) => {
    history.push("/book?coupon_seq=" + event.target.value);
  };

  const couponTabChange = (e, newValue) => {
    history.push("/mypage?tab=2&cate=" + newValue);
    setTab(newValue);
  };

  // const visibleClass = () => {
  //   setClassCoupon(true);
  //   setPassCoupon(false);
  //   setDiscountCoupon(false);
  // };
  // const visiblePass = () => {
  //   setClassCoupon(false);
  //   setPassCoupon(true);
  //   setDiscountCoupon(false);
  // };
  // const visibleDiscount = () => {
  //   setClassCoupon(false);
  //   setPassCoupon(false);
  //   setDiscountCoupon(true);
  // };

  // 패스쿠폰 이용 가능한 센터에 표시
  useState(async() => {
    if (cid) {
      let result = await axios.post(
        configState.api + "/gympass/get_basecode_text",
        {
          cid: cid,
          gubun: "use_pass_coupon",
        }
      );
      if (result.data.ret === 'Y') {
        setShowPassCoupon(true);
      }
    }
  }, [cid]);

  return (
    <Grid
      container
      // display="block"
      width="100%"
      justifyContent="center"
      alignItems="flex-end"
      position="absolute"
      top="170px"
    // overflow='hidden'
    >
      {/* 2차탭 */}
      <ThemeProvider theme={center.pt_coupon_sale === true ? tabPTTheme : tabTheme}>
        <TabContext value={tab} variant="scrollable" scrollButtons allowScrollButtonsMobile>
          <TabList onChange={couponTabChange}>
            <Tab label="클래스쿠폰" value="1" />
            {center.pt_coupon_sale === true &&
              <Tab label='PT쿠폰' value='2' />
            }
            {showPassCoupon &&
              <Tab label="패스쿠폰" value="3" />}
            <Tab label="할인쿠폰" value="4" />
          </TabList>

          <TabPanel
            value="1"
            sx={{
              width: "100%",
              padding: "15px 0",
            }}
          >
            <MypageLoggedCouponClass login={login} />
          </TabPanel>

          {center.pt_coupon_sale === true &&
            <TabPanel
              value="2"
              sx={{
                width: "100%",
                padding: "15px 0",
              }}
            >
              <MypageLoggedCouponPT login={login} />
            </TabPanel>
          }

          <TabPanel
            value="3"
            sx={{
              width: "100%",
              padding: "15px 0",
            }}
          >
            <MypageLoggedCouponPass login={login} />
          </TabPanel>

          <TabPanel
            value="4"
            sx={{
              width: "100%",
              padding: "15px 0",
            }}
          >
            <MypageLoggedCouponDiscount login={login} />
          </TabPanel>
        </TabContext>
      </ThemeProvider>
    </Grid>
  );
};

export default MypageLoggedCoupon;
